import { useCallback } from 'react';
import { deleteAccount } from 'actions';
import { muteAll, useFetchOld } from 'hooks';
import useRefreshAccounts from 'hooks/useRefreshAccounts';
export const useDeleteAccount = () => {
    const [, , , fetch] = useFetchOld(muteAll);
    const refreshAccounts = useRefreshAccounts();
    const close = useCallback((account) => {
        if (!account)
            return;
        fetch(deleteAccount(account.id)).then((response) => {
            if (response) {
                refreshAccounts(account.type);
            }
        });
    }, [fetch, refreshAccounts]);
    return close;
};
